import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, Stack, Typography, Skeleton} from 'views/components';

import {HoverToolBox, Translate, translate, MarkdownViewer} from 'views/module';

import ClientAuthentication from './ClientAuthentication';

const RelationshipView = (props) => {
  const [toolbarVisible, setToolbarVisible] = React.useState(false);
  const [mouseOver, setMouseOver] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const relationshipData = props.relationshipData;
  const removeRelationship = props.removeRelationship;
  const editRelationship = props.editRelationship;
  const clientBackend = props.clientBackend;
  const userIdentity = props.userIdentity;
  const clientAuthenticationLoading = props.clientAuthenticationLoading;

  React.useEffect(() => {
    const clientRelationshipRn = relationshipData.relationshipRn;
    clientBackend.user.getUser(clientRelationshipRn);
  }, [relationshipData.relationshipRn]);

  React.useEffect(() => {
    setToolbarVisible(mouseOver);
  }, [mouseOver]);

  return (
    <Box>
      <Divider />
      <Box
        onMouseOver={(e) => setMouseOver(true) & setAnchorEl(e.currentTarget)}
        onMouseLeave={(e) => setMouseOver(false)}
        sx={{
          backgroundColor: toolbarVisible ? 'background.highlighted' : 'inherit',
          p: 2,
        }}
      >
        <Stack
          spacing={1}
        >
          {/* Display Relationship Name */}
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.Name' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center'}}
            >
              {relationshipData.name}
            </Typography>
          </Box>
          <Box>
            {/* Display Connection Type */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.ConnectionType' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {relationshipData.connectionType}
            </Typography>
          </Box>
          <Box>
            {/* Display Priority */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.Priority' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {relationshipData.priority}
            </Typography>
          </Box>
          <Box>
            {/* Display Priority */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.Contacts' />
            </Typography>
            {relationshipData.contacts.map((contact, index) => {
              return (
                <Stack
                  key={index}
                  direction={'row'}
                  spacing={1}
                >
                  <Typography
                    sx={{
                      fontWeight: 500,
                    }}
                  >
                    {contact.type}
                  </Typography>
                  <Typography
                    sx={{
                    }}
                  >
                    {contact.detail}
                  </Typography>
                </Stack>
              );
            },
            )}
          </Box>

          <Box>
            {/* Display Description */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Details.Description' />
            </Typography>
            <MarkdownViewer
              value={relationshipData.description.blob || translate('client.ClientDetail.Relationships.Details.NoDescription')}
              truncate
              truncateLine={8}
            />
          </Box>
        </Stack>

        {/* Authentication Section*/}
        <Box sx={{}}>
          <Box sx={{mt: 2}}>
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Relationships.Authentication.Title' />
            </Typography>
            {
              clientAuthenticationLoading ? (
              <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '10px'}}>
                <Box>
                  <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.5}}>
                    <Skeleton variant="text" width={200} height={21} />
                    <Skeleton variant="text" width={100} height={22} />
                  </Box>
                </Box>
                <Skeleton variant="rectangular" width={120} height={36.5} sx={{borderRadius: 1}} />
              </Box>
            ) : (
              <ClientAuthentication
                clientBackend={clientBackend}
                relationshipData={relationshipData}
                userIdentity={userIdentity}
              />
            )}
          </Box>
        </Box>

        {/* Hover ToolBox */}
        <HoverToolBox
          toolBar={toolbarVisible}
          anchorEl={anchorEl}
          onClickDelete={() => removeRelationship(relationshipData.relationshipRn)}
          onClickEdit={() => editRelationship(relationshipData, userIdentity)}
          hideTool={{
            emoji: true,
            copy: true,
            edit: false,
            delete: false,
          }}
        />
      </Box>
    </Box>
  );
};

RelationshipView.propTypes = {
  relationshipData: PropTypes.object.isRequired,
  removeRelationship: PropTypes.func.isRequired,
  editRelationship: PropTypes.func.isRequired,
  clientBackend: PropTypes.object.isRequired,
  userIdentity: PropTypes.object,
  clientAuthenticationLoading: PropTypes.bool.isRequired,
};

export default React.memo(RelationshipView);
